import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

// Define a type for the slice state
export interface LookupListState {
  countries: any[];
}

// Define the initial state using that type
const initialState: LookupListState = {
  countries: [],
};

export const lookupListSlice = createSlice({
  name: "lookupList",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setCountries(
      state,
      action: PayloadAction<{
        countries: any[] | [];
      }>
    ) {
      state.countries = action.payload.countries;
    },
  },
});

export const { setCountries } = lookupListSlice.actions;

// Other code such as selectors can use the imported `RootState` type

export const getCountries = (state: RootState) => state.lookupList.countries;

export default lookupListSlice.reducer;
